<template>
  <div>
    <div class="widget-shell">
    <b-card class="widget-custom widget-card"
            :class="{ 'widget-card--mobile-collapsed': mobileCollapsed }"
            :no-body="true">

      <!-- CABECERA -->
      <div slot="header" class="widget-header-custom" v-if="!errorLoad">      
        <div class="widget-title-group">
          <b-link href="javascript:void(0);" v-b-tooltip.hover title="Arrastrar para mover" v-if="allowDrag" class="widget-header-action widget-drag-handle">
            <AppIcon icon="arrows-move" font-scale="1.05"></AppIcon>
          </b-link>
          <AppIcon name="question-circle" class="widget-header-action widget-info-custom" font-scale="1.25" weight="500" v-b-tooltip.hover :title="'(ID:' + widget.id + ') - ' + widget.description" />
          <strong class="widget-title">{{this.widget.title}}</strong>
          <b-link href="javascript:void(0);" v-b-tooltip.hover :title="titleFilters" @click="openFilter()" v-if="showApplyFilters && !(isMobileViewport && isChartWidget)" class="widget-header-action widget-filter-action">
            <AppIcon icon="filter" font-scale="1.05"></AppIcon>
          </b-link>
        </div>
        
        <div class="widget-actions">
          <span v-if="showMobileContentAlert"
                class="widget-mobile-content-alert"
                v-b-tooltip.hover
                title="Hay contenido para consultar">
            <AppIcon icon="info-circle" font-scale="0.9"></AppIcon>
          </span>
          <button v-if="isMobileViewport"
                  type="button"
                  class="widget-header-action widget-mobile-collapse"
                  :aria-expanded="String(!mobileCollapsed)"
                  :aria-label="mobileCollapsed ? 'Expandir widget' : 'Contraer widget'"
                  @click="toggleMobileCollapse">
            <AppIcon :icon="mobileCollapsed ? 'chevron-down' : 'chevron-up'" font-scale="1.05"></AppIcon>
          </button>
          <b-link href="javascript:void(0);" v-b-tooltip.hover title="Ocultar widget" @click="emitHide()" v-if="allowHide" class="widget-header-action widget-hide-custom">
            <AppIcon icon="eye-slash" font-scale="1.05"></AppIcon>
          </b-link>
        </div>
      </div>

      <!-- SPINER DE CARGA -->
      <div class="widget-loading-state" v-if="!finishLoad" v-show="!mobileCollapsed">
        <b-spinner variant="primary" small label="Cargando widget"></b-spinner>
        <span>Actualizando datos</span>
      </div>
      
      <!-- NO CONFIGURADO -->    
      <b-card-body class="widget-state widget-state--warning widget-body" v-if="widget.configured==0" v-show="!mobileCollapsed">
        <AppIcon icon="code-slash" font-scale="1.4"></AppIcon>
        <strong>Widget en desarrollo</strong>
        <span>Este contenido todavía no está configurado.</span>
        <b-badge variant="secondary">{{this.widget.type}}</b-badge>
      </b-card-body> 
      <div v-else class="widget-content-wrapper" v-show="!mobileCollapsed">
        <!-- GRAFICO -->
        <b-card-body v-if="!errorLoad && hasAccess"
                     class="widget-body"
                     :class="['widget-body--' + widget.type, { 'widget-body--manual': showManualLoad }]">
          <List v-if="widget.type=='list' && !this.iseEmpty(widget.data)" :data="widget.data"/>
          <Accordion v-if="widget.type=='accordion' && !this.iseEmpty(widget.data)" :data="widget.data"/>
          <Indicator v-if="widget.type=='indicator' && !this.iseEmpty(widget.data)" :data="widget.data" :colorText="primaryColor" />    
          <Iframe v-if="widget.type=='iframe' && widget.external_url" :data="widget.external_url" :height="widget.height" :title="widget.title" :subtitle="widget.description" :key="forceIframeSrc" />
          
          <button v-if="showMobileChartTrigger" type="button" class="widget-chart-mobile-trigger" @click="openChartPreview">
            <span class="widget-chart-mobile-trigger__icon"><AppIcon icon="arrows-fullscreen"></AppIcon></span>
            <span class="widget-chart-mobile-trigger__copy">
              <small>Vista optimizada para celular</small>
              <strong>Ver gráfico completo</strong>
              <span>Tocá para ampliarlo e interactuar con sus datos.</span>
            </span>
            <AppIcon icon="chevron-right" class="widget-chart-mobile-trigger__chevron"></AppIcon>
          </button>
          <div v-else-if="!isMobileViewport && validChartError && isChartWidget" class="widget-chart-panel" :class="'widget-chart-panel--' + widget.type">
            <BarChartIndicator v-if="widget.type=='bar-indicator' && !this.iseEmpty(widget.data)" :chartData="prepareDatasets(widget.data)" :options="prepareOptions(widget.data)" :indicators="prepareIndicators(widget.data)" />
            <BarChart v-if="widget.type=='bar' && !this.iseEmpty(widget.data)" :chartData="prepareDatasets(widget.data)" :options="prepareOptions(widget.data)" />
            <PieChart v-if="widget.type=='pie' && !this.iseEmpty(widget.data)" :chartData="prepareDatasets(widget.data)" :options="prepareOptions(widget.data)" />        
            <DoughnutChart v-if="widget.type=='doughnut' && !this.iseEmpty(widget.data)" :chartData="prepareDatasets(widget.data)" :options="prepareOptions(widget.data)" />        
          </div>
          <div v-if="!validChartError && isChartWidget">
            <div class="widget-state widget-state--neutral">
              <AppIcon icon="eye-slash" font-scale="1.35"></AppIcon>
              <span>{{this.widget.data}}</span>
            </div>          
          </div>

          <!-- SI ES ACTUALIZACION MANUAL -->       
          <div v-if="showManualLoad" class="widget-manual-load widget-manual-load--violet">
            <div class="widget-manual-load__icon" aria-hidden="true">
              <AppIcon name="database" />
            </div>
            <div class="widget-manual-load__copy">
              <strong>Datos disponibles para consultar</strong>
              <span>Este widget se actualiza solo cuando lo solicitás.</span>
            </div>
            <b-button type="button"
                      variant="primary"
                      class="widget-manual-load__action"
                      @click="forceUpdate('manual','load')"
                      v-b-tooltip.hover
                      title="Consultar datos manualmente">
              <AppIcon name="refresh" class="mr-1" /> Consultar datos
            </b-button>
          </div>
        </b-card-body>

        <!-- SIN PERMISOS -->
        <b-card-body class="widget-state widget-state--neutral widget-body" v-if="!errorLoad && !hasAccess && finishLoad">
          <AppIcon icon="eye-slash" font-scale="1.35"></AppIcon>
          <strong>Contenido restringido</strong>
          <span>Su usuario no tiene acceso al contenido de este widget.</span>
        </b-card-body>

        <!-- ERROR DE CONFIGURACION -->
        <b-card-body class="widget-state widget-state--danger widget-body" v-if="errorLoad && finishLoad">
          <AppIcon icon="exclamation-triangle" font-scale="1.35"></AppIcon>
          <strong>No se pudo cargar el widget</strong>
          <span>Revisá su configuración e intentá nuevamente.</span>
        </b-card-body>

        <!-- PIE: siempre visible, fuera del body scrolleable -->
        <div v-if="!errorLoad && hasAccess && finishLoad"
             class="widget-footer widget-ultima-actualizacion"
             :style="footerStyle"
             @click="forceUpdate('auto','click')">
          <span class="widget-router-custom" v-if="widget.router">
            <button type="button" @click.stop="go()" class="widget-footer-router"
                            v-b-tooltip.hover.left
                            title="Acceso directo. Click para acceder">
              {{ (widget.data && widget.data.router_label) || 'Ir >>' }}
            </button>
          </span>
          <span class="widget-footer-refresh"
                v-b-tooltip.hover.left
                title="Última actualización. Click para forzar actualización"
                style="position: relative;">
            <AppIcon name="clock" /> {{moment().format('HH:mm:ss')}}
          </span>
        </div>
      </div>

    </b-card>
    <div v-if="allowResize" class="widget-resize-handle widget-resize-handle-x" v-b-tooltip.hover title="Arrastrar para cambiar ancho"></div>
    <div v-if="allowResize" class="widget-resize-handle widget-resize-handle-y" v-b-tooltip.hover title="Arrastrar para cambiar alto"></div>
    </div>
 
    <!-- ########################### -->
    <!-- #####     MODALES     ##### -->
    <!-- ########################### -->

    <!-- CRUD FILTER --> 
    <b-modal v-model="modal.form.active"
            size="md"
            centered
            dialog-class="widget-filter-modal-dialog"
            id="widget-modal-filter">
      <div slot="modal-header" class="app-modal-header">
        <span class="app-modal-header__icon"><AppIcon icon="filter"></AppIcon></span>
        <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
      </div>

      <div class="app-modal-form widget-filter-form">
        <b-row no-gutters v-if="getShowFilter('date_start_end')">
          <b-col md="6" class="widget-filter-form__field widget-filter-form__field--left">
            <label>Desde</label>
            <b-form-input type="date" v-model="filter.date_start"></b-form-input>
          </b-col>
          <b-col md="6" class="widget-filter-form__field widget-filter-form__field--right">
            <label>Hasta</label>
            <b-form-input type="date" v-model="filter.date_end"></b-form-input>
          </b-col>
        </b-row>
        <b-row no-gutters v-if="getShowFilter('months_years')">
          <b-col v-if="hasFilterParam('$months')" :md="hasFilterParam('$years') ? '6' : '12'" class="widget-filter-form__field widget-filter-form__field--left">
            <label>Mes</label>
            <b-form-select v-model="filter.months" :options="opt.months"></b-form-select>
          </b-col>
          <b-col v-if="hasFilterParam('$years')" :md="hasFilterParam('$months') ? '6' : '12'" :class="hasFilterParam('$months') ? 'widget-filter-form__field widget-filter-form__field--right' : 'widget-filter-form__field'">
            <label>Año</label>
            <b-form-select v-model="filter.years" :options="opt.years"></b-form-select>
          </b-col>
        </b-row>
        <div class="widget-filter-form__field" v-if="getShowFilter('employees') && !isEmployee">
          <label>Project Manager</label>
          <v-select v-model="filter.employees" :options="opt.employees" placeholder="Seleccionar" :multiple="true" :select-on-tab="true"></v-select>
        </div>
      </div>

      <div slot="modal-footer" class="widget-filter-modal-footer">
        <b-button variant="outline-secondary" @click="modal.form.active=false">Cerrar</b-button>
        <b-button variant="dark" @click="applyFilter()"><AppIcon icon="filter"></AppIcon> Aplicar filtros</b-button>
      </div>
    </b-modal>

    <b-modal v-model="chartPreviewOpen" hide-footer scrollable dialog-class="widget-chart-mobile-dialog" content-class="widget-chart-mobile-modal-content" body-class="widget-chart-mobile-modal-body" @shown="chartPreviewReady = true" @hidden="chartPreviewReady = false">
      <div slot="modal-header" class="app-modal-header">
        <span class="app-modal-header__icon"><AppIcon icon="bar-chart"></AppIcon></span>
        <h5 class="app-modal-header__title">{{ widget.title }}</h5>
        <button type="button" class="close" aria-label="Cerrar gráfico" @click="chartPreviewOpen = false"><span aria-hidden="true">&times;</span></button>
      </div>
      <div v-if="chartPreviewReady" class="widget-chart-mobile-preview-shell">
        <div v-if="widget.description" class="widget-chart-mobile-preview-context">
          <AppIcon icon="info-circle"></AppIcon>
          <span>{{ widget.description }}</span>
        </div>
        <div v-if="showApplyFilters" class="widget-chart-mobile-preview-toolbar">
          <button type="button" class="widget-chart-mobile-preview-filter" @click="openFilter">
            <AppIcon icon="filter"></AppIcon> Filtrar
          </button>
        </div>
        <div v-if="hasWidgetContent" class="widget-chart-mobile-preview" :class="'widget-chart-mobile-preview--' + widget.type">
          <BarChartIndicator v-if="widget.type=='bar-indicator'" :key="'chart-preview-' + widget.type" :chartData="prepareDatasets(widget.data)" :options="prepareOptions(widget.data)" :indicators="prepareIndicators(widget.data)" />
          <BarChart v-if="widget.type=='bar'" :key="'chart-preview-' + widget.type" :chartData="prepareDatasets(widget.data)" :options="prepareOptions(widget.data)" />
          <PieChart v-if="widget.type=='pie'" :key="'chart-preview-' + widget.type" :chartData="prepareDatasets(widget.data)" :options="prepareOptions(widget.data)" />
          <DoughnutChart v-if="widget.type=='doughnut'" :key="'chart-preview-' + widget.type" :chartData="prepareDatasets(widget.data)" :options="prepareOptions(widget.data)" />
        </div>
        <div v-else class="widget-state widget-state--neutral">
          <AppIcon icon="info-circle" font-scale="1.35"></AppIcon>
          <span>No hay datos para mostrar con los filtros seleccionados.</span>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
  import moment from 'moment'
  import serviceAPI from './services'
  import Session from '@/handler/session'
  import Theme from '@/config/theme'
  import ErrorToken from '@/handler/errorToken'
  import Helper from '@/handler/helper'
  import Indicator from './_indicator'
  import List from './_list'
  import Accordion from './_accordion'
  import BarChart from './_chartBar'
  import PieChart from './_chartPie'
  import DoughnutChart from './_chartDoughnut'  
  import Iframe from './_iframe.vue'
  import BarChartIndicator from './_chartBarIndicator'
  import Param from '@/config/parameters'
  import StorageLocal from '@/handler/storageLocal'

  export default {
    components: {
      BarChart,
      PieChart,
      DoughnutChart,
      List,
      Accordion,
      Indicator,
      Iframe,
      BarChartIndicator,
    },
    props: {
      configWidget: {
        type: Object,
        required: true
      },
      reference: {
        type: String,
        required: true
      },
      hasAccess: {
        type: Boolean,
        required: true
      },
      isCustom: {
        type: Boolean,        
        default: false,
      },
      allowHide: {
        type: Boolean,
        default: false,
      },
      allowDrag: {
        type: Boolean,
        default: false,
      },
      allowResize: {
        type: Boolean,
        default: false,
      }
    },
    data: () => {
      return {
        widget: {},
        widgetCallFunctionParams: [],
        finishLoad: false,
        errorLoad: false,
        config: {},
        interval: null,
        primaryColor: Theme.PRIMARY_COLOR,
        modal: {
          form: {
            active: false,
            title: ''
          },  
        },
        filter: {          
          date_start: '',
          date_end: '',          
          months: '',
          years: '',
          employees: '',
        },
        opt: {
          months: [],
          years: [],    
          employees: [],      
        },
        updateManual: false,
        forceIframeSrc: 0,
        chartPreviewOpen: false,
        chartPreviewReady: false,
        isMobileViewport: false,
        mobileCollapsed: false,
        _start: false,
      }
    },
    mounted() {
      this.updateMobileState()
      window.addEventListener('resize', this.updateMobileState)
      this.updateManual = Helper.hasParametersAccess(Param.P63)

      this.load() 
      
      if(!this.updateManual) {
        this.loadCallFunction()
      }      
      
      this.setColorPrimary()    

      this.prepareFilter()    
      
      this._start = true      
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      } 

      if(this.updateManual) {
        this.forceUpdate('manual','load')    
      } else {
        this.forceUpdate('auto','load')    
      }      
    },
    destroyed () {      
      clearInterval(this.interval)      
    },    
    beforeDestroy() {
      window.removeEventListener('resize', this.updateMobileState)
    },
    computed: {
      footerStyle() {
        return {}
      },
      validChartError() {
        var result = true
        if(this.widget.type != 'list' && this.widget.type != 'accordion' && this.widget.type != 'indicator'){

          if(typeof(this.widget.data) == 'string') {          
            result = false
          }
          
        }  
        return result      
      },
      isChartWidget() {
        return ['bar', 'bar-indicator', 'pie', 'doughnut'].includes(this.widget.type)
      },
      showManualLoad() {
        return !this.showMobileChartTrigger && this.finishLoad && this.updateManual && (
          (this.widget.type === 'iframe' && !this.widget.external_url) ||
          (this.widget.type !== 'iframe' && this.iseEmpty(this.widget.data))
        )
      },
      hasWidgetContent() {
        if(this.widget.type === 'iframe') {
          return !!this.widget.external_url
        }

        const data = this.widget.data
        if(data === null || data === undefined || data === '') return false
        if(typeof data === 'string') return false
        if(['list', 'accordion'].includes(this.widget.type)) {
          return !!(data && Array.isArray(data.items) && data.items.length)
        }
        if(this.isChartWidget) {
          const datasets = data && data.chartData && data.chartData.datasets
          return Array.isArray(datasets) && datasets.some(dataset => {
            return Array.isArray(dataset.data) && dataset.data.length > 0
          })
        }
        if(Array.isArray(data)) return data.length > 0
        if(typeof data === 'object' && this.isEmptyWidgetMessage(data.message)) return false
        return true
      },
      showMobileChartTrigger() {
        return this.isMobileViewport && this.validChartError && this.isChartWidget
      },
      showMobileContentAlert() {
        return this.isMobileViewport &&
          this.finishLoad &&
          !this.errorLoad &&
          this.hasAccess &&
          this.widget.configured != 0 &&
          this.hasWidgetContent
      },
      showApplyFilters(){
        if(this.widgetCallFunctionParams.length) {
          return true
        } else {
          return false
        }
      },   
      titleFilters() {
        var titleFilters = ''        

        if(this.getShowFilter('date_start_end')) {
          if(this.filter.date_start && this.filter.date_end) {
            titleFilters = 'Desde: ' + moment(this.filter.date_start).format('DD/MM/YYYY') + ' - Hasta: ' + moment(this.filter.date_end).format('DD/MM/YYYY')          
          } 
        }
        
        if(this.getShowFilter('months_years')) {
          if(this.hasFilterParam('$months') && this.hasFilterParam('$years') && this.filter.months && this.filter.years) {
            if(titleFilters) {
              titleFilters = titleFilters + ' | '
            } 

            titleFilters = titleFilters + this.getNameMonths(this.filter.months) + ' ' + this.filter.years           
          }

          if(!this.hasFilterParam('$months') && this.hasFilterParam('$years') && this.filter.years) {
            if(titleFilters) {
              titleFilters = titleFilters + ' | '
            }

            titleFilters = titleFilters + this.filter.years
          }

          if(this.hasFilterParam('$months') && !this.hasFilterParam('$years') && this.filter.months) {
            if(titleFilters) {
              titleFilters = titleFilters + ' | '
            }

            titleFilters = titleFilters + this.getNameMonths(this.filter.months)
          }
        }

        if(this.getShowFilter('employees')) {
          if(this.filter.employees) {
            if(titleFilters) {
              titleFilters = titleFilters + ' | '
            } 

            if(this.filter.employees) {
              this.filter.employees.forEach(element => {
                titleFilters = titleFilters + element['label'] + ', '    
              });
              titleFilters = titleFilters.slice(0,-2)
            }          
          }        
        }

        if(!titleFilters) {
          titleFilters = 'Aplicar Filtros'
        }
        
        return titleFilters
      },
      isEmployee(){
        if(Helper.getEmployee()) {
          if(Helper.getEmployee().permission_admin_projects) {
            return false  
          } else {
            return true
          }                    
        } else {
          return false
        }
      },         
    },
    watch: {
      'widget.type'(type) {
        if(this.isMobileViewport && type === 'indicator') {
          this.mobileCollapsed = false
        }
      },
    },
    methods: {
      updateMobileState() {
        const isMobile = window.innerWidth <= 767
        if(isMobile && !this.isMobileViewport) {
          this.mobileCollapsed = this.widget.type !== 'indicator'
        } else if(!isMobile) {
          this.mobileCollapsed = false
          this.chartPreviewOpen = false
        }
        this.isMobileViewport = isMobile
      },
      toggleMobileCollapse() {
        if(this.isMobileViewport) {
          this.mobileCollapsed = !this.mobileCollapsed
        }
      },
      openChartPreview() {
        if(!this.updateManual) {
          this.chartPreviewOpen = true
          return
        }

        this.forceUpdate('manual', 'load')
          .then((loaded) => {
            if(loaded) {
              this.chartPreviewOpen = true
            }
          })
      },
      isEmptyWidgetMessage(value) {
        if(typeof value !== 'string') return false
        return /^(sin novedades|sin datos|no hay datos|no hay registros|sin resultados)\.?$/i.test(value.trim())
      },
      iseEmpty(valor) {
        return (
            valor === 0 || 
            valor === "" || 
            valor === null || 
            valor === undefined || 
            (Array.isArray(valor) && valor.length === 0)
        )
      },      
      load () {
        this.config = {
          profile_id: this.configWidget.profile_id,
          module_id: this.configWidget.module_id,
          reference: this.reference,
          filter: this.filter,
          stringCallFunction: false, 
        }

        var result = null
        var data = null
        if(this.isCustom) {
          result = serviceAPI.mostrarByReferenciaCustom(this.config)
        } else {
          // La caché se arma al iniciar sesión: un widget nuevo todavía no está
          const cached = JSON.parse(StorageLocal.getValue('configWidget'));
          data = cached ? cached.find(item => item.reference === this.reference) : null
          if(!data) {
            result = serviceAPI.mostrarByReferencia(this.config) 
          }          
        }

        if(data) {
          data.data = this.initValueWidget(data)
          
          this.widget = data
          this.finishLoad = true
          this.errorLoad = false

          this.reload(data.configured, data.time_refresh)          
        } else {
          result.then((response) => {          
            var data = response.data

            data.data = this.initValueWidget(data)
            
            this.widget = data
            this.finishLoad = true
            this.errorLoad = false

            this.reload(data.configured, data.time_refresh)
          })
          .catch(error => {
            this.finishLoad = true
            this.errorLoad = false
            this.$awn.alert(ErrorToken.valid(error))          
          });
        }              
      },
      loadCallFunction() {
        this.config = {
          profile_id: this.configWidget.profile_id,
          module_id: this.configWidget.module_id,
          reference: this.reference,
          filter: this.filter,
          stringCallFunction: true, 
        }

        var result = null
        if(this.isCustom) {
          result = serviceAPI.mostrarByReferenciaCustom(this.config)
        } else {
          result = serviceAPI.mostrarByReferencia(this.config)
        }

        result.then((response) => {
          var data = response.data
          this.widgetCallFunctionParams = data      

          this.forceUpdate('auto','load')    
        })
        .catch(error => {          
          this.$awn.alert(ErrorToken.valid(error))          
        });
      },
      reload(configured, timeRefresh) {    
        if (configured) {                              
          if(!this.updateManual) {

            this.interval = setInterval(() => {     

              this.config.stringCallFunction = false
              
              var result = null
              if(this.isCustom) {
                result = serviceAPI.mostrarByReferenciaCustom(this.config)
              } else {
                result = serviceAPI.mostrarByReferencia(this.config)
              }

              result.then((response) => {
                var data = response.data
                data.data = this.initValueWidget(data)
                this.widget = data
              })
              .catch(error => {
                this.$awn.alert(ErrorToken.valid(error));        
              })              
            }, timeRefresh);
          }  
        }
      },
      forceUpdate(type='auto', action='') {
        if(type=='manual') {
          this.finishLoad = false
        }

        this.config.stringCallFunction = false
        
        var result = null
        if(this.isCustom) {
          result = serviceAPI.mostrarByReferenciaCustom(this.config)
        } else {
          result = serviceAPI.mostrarByReferencia(this.config)
        }

        return result.then((response) => {
          var data = response.data
          data.data = this.initValueWidget(data)
          this.widget = data

          if(action == 'click') {
            if(this.widget.type == 'iframe') {
              this.forceIframeSrc++
            }
          }

          if(type=='manual') {
            const result_alt = JSON.parse(StorageLocal.getValue('configWidget'));
            const result_data = result_alt && result_alt.find(item => item.reference === this.reference);
            if(result_data && typeof result_data.dataCallback === 'string') {
              const call = result_data.dataCallback.indexOf('$');
              if (call !== -1) {
                const match = result_data.dataCallback.match(/\(([^)]+)\)/);
                if (match) {
                  const arrParam = match[1].split(',').map(param => param.trim());
                  this.widgetCallFunctionParams = arrParam
                }
              }
            }

            this.finishLoad = true
          }

          return true
        })
        .catch(error => {
          if(type=='manual') {
            this.finishLoad = true
          }
          this.$awn.alert(ErrorToken.valid(error));
          return false
        })
      },
      emitHide() {
        this.$emit('hide-widget', this.reference)
      },
      go () {
        this.$router.push({ name: this.widget.router })        
      },
      initValueWidget(data) {
        var value = null
        if(data.data == null) {
          switch (data.type) {
            case 'indicator':
              value = 0
              break

            case 'pie':
              value = []
              break

            case 'bar':
              value = []
              break
          }
        } else {
          value = data.data
        }
        return value
      },
      setColorPrimary() {
        if(Session.getSession().settings) {    
          this.primaryColor = Theme.PRIMARY_COLOR
        }
      },
      prepareDatasets(data) {  
        return data.chartData
      },
      prepareOptions(data) {                    
        return data.options
      },
      prepareIndicators(data) {                    
        return data.indicators
      },      
      prepareFilter() {
        // prepare months
          this.opt.months.push({value:'01', text:'Enero'})
          this.opt.months.push({value:'02', text:'Febrero'})
          this.opt.months.push({value:'03', text:'Marzo'})
          this.opt.months.push({value:'04', text:'Abril'})
          this.opt.months.push({value:'05', text:'Mayo'})
          this.opt.months.push({value:'06', text:'Junio'})
          this.opt.months.push({value:'07', text:'Julio'})
          this.opt.months.push({value:'08', text:'Agosto'})
          this.opt.months.push({value:'09', text:'Septiembre'})
          this.opt.months.push({value:'10', text:'Octubre'})
          this.opt.months.push({value:'11', text:'Noviembre'})
          this.opt.months.push({value:'12', text:'Diciembre'})
        // fin

        // prepare yeras
          var yearNow = moment().format('YYYY')
          var yearLimit = 2015

          for (let index = yearLimit; index <= yearNow; index++) {
            this.opt.years.push({
              value: index,
              text: index,
            })
          } 
          this.opt.years = this.opt.years.reverse()    
        // fin

        // prepare employee
          this.filterLoadEmployees()
        // fin
      },
      openFilter(){        
        if(this.hasFilterParam('$months') && !this.filter.months) {
          this.filter.months = moment().format('MM')
        }
        
        if(this.hasFilterParam('$years') && !this.filter.years) {
          this.filter.years = moment().format('YYYY')
        }

        if(!this.filter.date_start) {
          this.filter.date_start = moment().startOf('month').format('YYYY-MM-DD');
        }

        if(!this.filter.date_end) {
          this.filter.date_end = moment().endOf('month').format('YYYY-MM-DD');
        }
      
        this.modal.form.title = "Filtrar '" + this.widget.title + "'"
        this.modal.form.active = true
      }, 
      applyFilter() {
        this.config.filter = this.filter        
        this.modal.form.active = false        
        this.forceUpdate('auto','filter')
      },
      hasFilterParam(param) {
        if(!this.widgetCallFunctionParams || !this.widgetCallFunctionParams.length) {
          return false
        }
        return this.widgetCallFunctionParams.includes(param)
      },
      getShowFilter(value) {
        if(value == 'date_start_end') {
          return this.hasFilterParam('$date_start') || this.hasFilterParam('$date_end')
        }
        
        if(value == 'months_years') {
          return this.hasFilterParam('$months') || this.hasFilterParam('$years')
        }

        if(value == 'employees') {
          return this.hasFilterParam('$employees')
        }

        return false
      },
      getNameMonths(value) {
        var name = ''
        this.opt.months.forEach(element => {
          if(element.value == value) {
            name = element.text
          }
        });
        return name
      },
      filterLoadEmployees() {
        var result_alt = JSON.parse(StorageLocal.getValue('configWidgetEmployee'));
        if(result_alt) {          
          var data = result_alt

          this.opt.employees = []
          data.forEach(element => {            
            this.opt.employees.push({ code: element.id, label: element.name })            
          });
        } else {
          var result = serviceAPI.obtenerEmpleado()        
          result.then((response) => {
            var data = response.data    

            this.opt.employees = []
            data.forEach(element => {            
              this.opt.employees.push({ code: element.id, label: element.name })            
            });          
          })   
        }
      },      
    }
  }
</script>
<style scoped>
  .widget-shell {
    position: relative;
  }
  .widget-card {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid var(--app-color-border);
    border-radius: 12px;
    background: var(--app-color-surface);
    box-shadow: var(--app-shadow-sm);
    transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
  }
  .widget-card:hover {
    border-color: var(--app-color-primary-200);
    box-shadow: var(--app-shadow-md);
  }
  .widget-header-custom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 48px;
    padding: 9px 12px;
    border-bottom: 1px solid var(--app-color-primary-300);
    background: linear-gradient(90deg, var(--app-color-primary-soft), var(--app-color-surface-subtle));
  }
  .widget-title-group {
    display: flex;
    align-items: center;
    min-width: 0;
    gap: 7px;
  }
  .widget-title {
    overflow: hidden;
    color: var(--app-color-primary-active);
    font-size: var(--app-text-base);
    font-weight: var(--app-font-semibold);
    line-height: var(--app-leading-compact);
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .widget-actions {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    gap: 4px;
  }
  .widget-header-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 28px;
    height: 28px;
    border-radius: 7px;
    color: var(--app-color-icon);
    text-decoration: none;
    transition: background-color 0.15s ease, color 0.15s ease, transform 0.15s ease;
  }
  .widget-header-action:hover,
  .widget-header-action:focus {
    outline: none;
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary);
    text-decoration: none;
    transform: translateY(-1px);
  }
  .widget-mobile-collapse {
    border: 0;
    background: transparent;
    cursor: pointer;
  }
  .widget-drag-handle {
    cursor: grab;
  }
  .widget-drag-handle:active {
    cursor: grabbing;
  }
  .widget-info-custom {
    border: 1px solid var(--app-color-primary-100);
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary);
  }
  .widget-content-wrapper {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
  .widget-body {
    flex: 1 1 auto;
    min-height: 0;
    padding: 12px 14px !important;
  }
  .widget-custom .card-body.widget-body {
    padding: 12px 14px !important;
  }
  .widget-body--iframe {
    padding: 0 !important;
  }
  .widget-body--list {
    padding: 10px 12px !important;
  }
  .widget-body--manual {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .widget-manual-load {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 116px;
    gap: 12px;
    padding: 16px;
    border: 1px dashed var(--app-color-primary-300);
    border-radius: 10px;
    background: linear-gradient(110deg, var(--app-color-primary-soft), var(--app-color-surface-subtle));
  }
  .widget-manual-load__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: var(--app-color-surface);
    color: var(--app-color-primary);
    box-shadow: var(--app-shadow-sm);
  }
  .widget-manual-load__copy {
    display: flex;
    flex: 0 1 auto;
    flex-direction: column;
    min-width: 0;
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-sm);
    line-height: var(--app-leading-default);
  }
  .widget-manual-load__copy strong {
    color: var(--app-color-text);
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-semibold);
  }
  .widget-manual-load__action {
    flex: 0 0 auto;
    margin-left: 4px;
    border-radius: 7px;
    font-weight: var(--app-font-semibold);
    white-space: nowrap;
  }
  .widget-manual-load--violet { border-color: #c4b5fd; background: linear-gradient(110deg, #f5f3ff, var(--app-color-surface-subtle)); }
  .widget-manual-load--violet .widget-manual-load__icon { color: #7c3aed; }
  .widget-manual-load--violet .widget-manual-load__action { border-color: #7c3aed; background: #7c3aed; }
  .widget-manual-load--violet .widget-manual-load__action:hover,
  .widget-manual-load--violet .widget-manual-load__action:focus { border-color: #6d28d9; background: #6d28d9; }
  @media (max-width: 575.98px) {
    .widget-manual-load {
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 10px;
      padding: 14px;
    }
    .widget-manual-load__copy {
      flex: 1 1 calc(100% - 48px);
    }
    .widget-manual-load__action {
      width: 100%;
      margin-left: 0;
    }
  }
  .widget-chart-mobile-trigger {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
    padding: 12px;
    overflow: hidden;
    border: 1px solid var(--app-color-primary-200);
    border-radius: 10px;
    background: linear-gradient(110deg, var(--app-color-primary-soft) 0%, var(--app-color-surface) 72%);
    color: var(--app-color-text-secondary);
    text-align: left;
  }
  .widget-chart-mobile-trigger::before { position: absolute; top: 0; bottom: 0; left: 0; width: 4px; background: var(--app-color-primary); content: ''; }
  .widget-chart-mobile-trigger__icon { display: inline-flex; flex: 0 0 34px; align-items: center; justify-content: center; width: 34px; height: 34px; border-radius: 9px; background: var(--app-color-primary); color: var(--app-color-on-primary); }
  .widget-chart-mobile-trigger__copy { display: flex; flex: 1 1 auto; flex-direction: column; min-width: 0; gap: 2px; }
  .widget-chart-mobile-trigger__copy small { color: var(--app-color-primary); font-size: 0.62rem; font-weight: var(--app-font-bold); letter-spacing: 0.06em; text-transform: uppercase; }
  .widget-chart-mobile-trigger__copy strong { color: var(--app-color-primary-active); font-size: var(--app-text-sm); }
  .widget-chart-mobile-trigger__copy span { font-size: var(--app-text-xs); line-height: 1.35; }
  .widget-chart-mobile-trigger__chevron { flex: 0 0 auto; color: var(--app-color-primary); }
  @media (max-width: 767.98px) {
    .widget-card--mobile-collapsed .widget-header-custom {
      border-bottom-color: transparent;
    }
    .widget-mobile-collapse {
      border: 1px solid var(--app-color-primary-100);
      background: var(--app-color-surface);
      color: var(--app-color-primary);
    }
    .widget-mobile-content-alert {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      border: 1px solid var(--app-color-primary-200);
      border-radius: 7px;
      background: var(--app-color-primary);
      box-shadow: var(--app-shadow-sm);
      color: var(--app-color-on-primary);
    }
  }
  .widget-chart-panel {
    position: relative;
    min-height: 218px;
    padding: 4px 0 0;
  }
  .widget-chart-panel--bar,
  .widget-chart-panel--bar-indicator {
    min-height: 238px;
  }
  .widget-chart-panel--pie,
  .widget-chart-panel--doughnut {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .widget-chart-panel > canvas {
    display: block;
    max-width: 100%;
  }
  .widget-footer {
    position: relative;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-height: 30px;
    padding: 5px 10px;
    border-top: 1px solid var(--app-color-border);
    background: var(--app-color-surface-subtle);
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;
  }
  .widget-footer:hover {
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary);
  }
  .widget-router-custom {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  .widget-footer-router {
    display: inline-flex;
    align-items: center;
    min-height: 26px;
    padding: 3px 9px;
    border: 1px solid var(--app-color-primary-200);
    border-radius: 6px;
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary);
    font: inherit;
    font-weight: var(--app-font-semibold);
    cursor: pointer;
  }
  .widget-footer-router:hover,
  .widget-footer-router:focus {
    border-color: var(--app-color-primary);
    background: var(--app-color-primary);
    color: var(--app-color-on-primary);
    outline: none;
  }
  .widget-footer-refresh {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    position: relative;
  }
  .widget-loading-state,
  .widget-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 116px;
    padding: 20px;
    gap: 7px;
    color: var(--app-color-text-muted);
    font-size: var(--app-text-sm);
    text-align: center;
  }
  .widget-loading-state {
    flex-direction: row;
    min-height: 88px;
  }
  .widget-state strong {
    color: var(--app-color-text);
    font-size: var(--app-text-base);
  }
  .widget-state--neutral {
    color: var(--app-color-text-muted);
  }
  .widget-state--warning {
    color: var(--app-color-warning-hover);
  }
  .widget-state--warning strong {
    color: var(--app-color-warning-hover);
  }
  .widget-state--danger {
    color: var(--app-color-danger);
  }
  .widget-state--danger strong {
    color: var(--app-color-danger-hover);
  }
  .widget-resize-handle {
    position: absolute;
    opacity: 0.16;
    z-index: 5;
  }
  .widget-resize-handle::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 2px;
    background: var(--app-color-primary);
    border-radius: 2px;
  }
  .widget-resize-handle-x {
    right: 0;
    top: 0;
    bottom: 0;
    width: 10px;
    cursor: ew-resize;
  }
  .widget-resize-handle-x::after {
    right: 3px;
  }
  .widget-resize-handle-y {
    left: 0;
    right: 0;
    bottom: 0;
    height: 10px;
    cursor: ns-resize;
  }
  .widget-resize-handle-y::after {
    top: 3px;
    left: 0;
    right: 0;
    width: auto;
    height: 2px;
  }
  .widget-resize-handle:hover {
    opacity: 0.72;
  }
</style>
<style>
  @media (max-width: 767.98px) {
    .widget-chart-mobile-dialog { width: calc(100vw - 16px); max-width: none; height: calc(100% - 16px); margin: 8px auto; }
    .widget-chart-mobile-modal-content { height: 100%; border: 1px solid var(--app-color-border); }
    .widget-chart-mobile-modal-body { display: flex; flex: 1 1 auto; min-height: 0; padding: 12px; overflow: hidden; }
    .widget-chart-mobile-preview-shell { display: flex; flex: 1 1 auto; flex-direction: column; min-height: 0; }
    .widget-chart-mobile-preview-context { display: flex; align-items: flex-start; gap: 7px; margin-bottom: 10px; padding: 9px 10px; border: 1px solid var(--app-color-primary-100); border-radius: 8px; background: var(--app-color-primary-soft); color: var(--app-color-text-secondary); font-size: var(--app-text-xs); line-height: 1.4; }
    .widget-chart-mobile-preview-context .app-icon { flex: 0 0 auto; margin-top: 1px; color: var(--app-color-primary); }
    .widget-chart-mobile-preview-context span { min-width: 0; overflow-wrap: anywhere; }
    .widget-chart-mobile-preview-toolbar { display: flex; justify-content: flex-end; margin-bottom: 8px; }
    .widget-chart-mobile-preview-filter { display: inline-flex; align-items: center; gap: 5px; padding: 6px 10px; border: 1px solid var(--app-color-primary-200); border-radius: 7px; background: var(--app-color-primary-soft); color: var(--app-color-primary); font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); }
    .widget-chart-mobile-preview { flex: 1 1 auto; min-height: 0; }
    .widget-chart-mobile-preview--bar-indicator { display: flex; flex-direction: column; }
    .widget-chart-mobile-preview canvas { max-height: 100%; }
  }
  .widget-filter-form { display: grid; gap: 14px; }
  .widget-filter-form__field { padding: 0 6px; }
  .widget-filter-form__field--left { padding-left: 0; padding-right: 7px; }
  .widget-filter-form__field--right { padding-right: 0; padding-left: 7px; }
  .widget-filter-form label { display: block; margin: 0 0 6px; color: var(--app-color-text-muted); font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); letter-spacing: .04em; text-transform: uppercase; }
  .widget-filter-form .form-control, .widget-filter-form .custom-select { min-height: 38px; border-color: var(--app-color-border); border-radius: 8px; color: var(--app-color-text); font-size: var(--app-text-sm); }
  .widget-filter-modal-footer { display: flex; justify-content: flex-end; gap: 10px; }
  @media (max-width: 575.98px) {
    .widget-filter-modal-dialog { width: calc(100% - 20px); margin: 10px auto; }
    .widget-filter-modal-body { padding: 14px; }
    .widget-filter-form { gap: 10px; }
    .widget-filter-form__field, .widget-filter-form__field--left, .widget-filter-form__field--right { padding: 0; }
    .widget-filter-form__field--left { margin-bottom: 10px; }
    .widget-filter-modal-footer .btn { display: inline-flex; flex: 1 1 0; align-items: center; justify-content: center; gap: 6px; margin: 0; }
  }
</style>
